import React from 'react';
import { Button, MessageBlock } from '../../../ui';
import './SuggestedDataLoadState.css';

function SuggestedDataLoadState({
  loading,
  failed,
  loadingLabel,
  onRetry
}) {
  if (loading) {
    return (
      <div className="rg-sale-suggested-load">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
        <p className="rg-sale-suggested-load__label">{loadingLabel}</p>
        {onRetry ? (
          <Button type="button" variant="outlineSecondary" size="sm" onClick={onRetry}>
            Reintentar
          </Button>
        ) : null}
      </div>
    );
  }

  if (failed) {
    return (
      <MessageBlock
        tone="warning"
        title="No se pudieron cargar las sugerencias"
        actions={
          onRetry ? (
            <Button type="button" variant="primary" size="sm" onClick={onRetry}>
              Reintentar
            </Button>
          ) : null
        }
      >
        La consulta tardó demasiado o falló. Podés reintentar sin salir de la venta.
      </MessageBlock>
    );
  }

  return null;
}

/**
 * Keeps section fields and "Nuevo" actions available when suggestions fail.
 * Only the loading spinner replaces the body; a failed load is a banner above children.
 */
export function SuggestedDataSection({
  loading,
  failed,
  loadingLabel,
  onRetry,
  children
}) {
  if (loading) {
    return (
      <SuggestedDataLoadState
        loading
        failed={false}
        loadingLabel={loadingLabel}
        onRetry={onRetry}
      />
    );
  }

  return (
    <>
      {failed ? (
        <div className="mb-3">
          <SuggestedDataLoadState
            loading={false}
            failed
            loadingLabel={loadingLabel}
            onRetry={onRetry}
          />
        </div>
      ) : null}
      {children}
    </>
  );
}

export default SuggestedDataLoadState;
